import { useMutation } from '@tanstack/react-query';

import { queryClient } from '~app/query-client';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

import type {
  DetectConflictsDto,
  DetectConflictsResponse,
} from '../model/recital';

export interface DetectConflictsParams {
  recitalId: string;
  data?: DetectConflictsDto;
}

export const detectConflictsAPI = async ({
  recitalId,
  data,
}: DetectConflictsParams) => {
  const response = await baseAPI.post<DetectConflictsResponse>(
    `/recitals/${recitalId}/detect-conflicts`,
    data ?? {},
  );
  return response.data;
};

export const useDetectConflictsMutation = () => {
  return useMutation({
    mutationFn: async (params: DetectConflictsParams) => {
      return await detectConflictsAPI(params);
    },
    onSuccess: (_, variables) => {
      void queryClient.invalidateQueries({
        queryKey: [KEYS.CONFLICTS, variables.recitalId],
      });
      void queryClient.invalidateQueries({
        queryKey: [KEYS.RECITALS, variables.recitalId],
      });
    },
  });
};
